export enum DashboardType {
  General = "General",
  Sectoral = "Sectoral",
  Consultant = "Consultant",
}
